import { AppBar, SxProps } from '@mui/material';
import { LogoButtons } from './LogoButtons';
import { PersonalAreaButton } from './PersonalAreaButton';
import { useIsDesktop, useIsWebView } from 'Hooks';

interface IPublicHeader {
  style?: SxProps;
}

export const PublicHeader = ({ style }: IPublicHeader) => {
  const isDesktop = useIsDesktop();
  const isWebView = useIsWebView();

  if (isWebView) return null;

  return (
    <AppBar
      position='sticky'
      sx={{
        display: 'flex',
        flexFlow: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#081E54',
        height: '72px',
        width: '100%',
        padding: isDesktop ? '5px 48px' : '5px 24px',
        zIndex: 50000,
        ...style,
      }}
    >
      <LogoButtons />
      <PersonalAreaButton />
    </AppBar>
  );
};
